module.exports = __webpack_public_path__ + "static/media/hatti-in-janti.e9f5c745.png";